
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.156 5h17.688l.156.844 2 13V27H5v-8.156l2-13zm1.719 2L7.187 18H14v1c0 1.117.883 2 2 2s2-.883 2-2v-1h6.813L23.125 7H8.875zM7 20v5h18v-5h-5.188c-.453 1.711-1.966 3-3.813 3s-3.359-1.289-3.813-3H6.998z"}})])
          )
        }
      }
    